<template>
  <div data-grm-comp="RoomCBTLogList">
    <table>
      <colgroup>
        <col width="12%">
        <col width="4%">
        <col width="5%">
        <col width="16%">
        <col width="5%">
        <col width="6%">
      </colgroup>
      <thead>
      <tr>
        <th>제목</th>
        <th>문항 수</th>
        <th>응시자 수</th>
        <th>출제 기간</th>
        <th>제한 시간</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(roomCBT) in cbtLogList" :key="roomCBT.roomCbtId">
        <td>{{ roomCBT.roomCbtTitle }}</td>
        <td>{{ roomCBT.cbt.questionList.length }}</td>
        <td>{{ roomCBT.roomCbtUserCnt }}</td>
        <td>{{ dayjs(roomCBT.beginDate).format('YYYY-MM-DD HH:mm:ss') }} ~ {{ dayjs(roomCBT.endDate).format('YYYY-MM-DD HH:mm:ss') }}</td>
        <td>{{ duration(roomCBT.duration) }}</td>
        <td>
          <div class="flex justify-center items-center gap-1">
            <GrmBtn size="xs" @click="onSelectCBT(roomCBT)">상세보기</GrmBtn>
          </div>
        </td>
      </tr>
      <tr v-if="cbtLogList.length === 0">
        <td colspan="6">출제 이력이 없습니다.</td>
      </tr>
      </tbody>
    </table>

    <GrmPagination class="mt-3" :page-info="cbtLogListPageInfo" @paging="onChangePage" />
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import dayjs from "dayjs";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmPagination from "@/components/Common/pagination/GrmPagination.vue";
import RoomCBTLogDetail from "@/components/Room/CBT/RoomCBTLogDetail.vue";

export default {
  name: 'RoomCBTLogList',
  components: {
    GrmBtn,
    GrmPagination,
  },
  computed: {
    ...mapState('cbt', [
      'cbtLogList',
      'cbtLogListPageInfo'
    ]),

    duration() {
      return duration => {
        const hour = Math.floor(duration / 3600);
        const minute = Math.floor((duration % 3600) / 60);
        const second = duration % 60;
        return `${hour ? hour + this.$t('common.hour') + ' ' : ''}${minute ? minute + this.$t('common.minute') + ' ' : ''}${second ? second + this.$t('common.second') : ''}`;
      }
    }
  },
  methods: {
    ...mapActions('cbt', [
      'getCBTLog',
      'getCBTLogList',
    ]),

    dayjs,
    async onSelectCBT(roomCBT) {
      try {
        await this.getCBTLog({ roomCbtId: roomCBT.roomCbtId })
        this.$modal(RoomCBTLogDetail)
      } catch (e) {
        console.error(e)
        this.$alert(this.$t('roomCbt.alert.failedLoadCbt'))
      }
    },
    async onChangePage(page) {
      try {
        await this.getCBTLogList({
          searchText: '',
          page: page,
          size: 10
        })
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  font-size: 13px;
  text-align: center;
  table-layout: fixed;
  border: 1px solid #ccc;
}
thead {
  tr {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
tbody {
  tr {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    &:first-child {
      border-top: none;
    }
  }
}
tr {
  height: 40px;
  white-space: nowrap;
}
th {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
td {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
</style>